import { Observable } from 'rxjs';

import { catchError, map } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ISignUp,
  IUserStatus,
  IExternalData,
  ISetPassword,
  IUser,
} from '../../commons';
import { environment } from '../../environments/environment';

// import { jsPDF } from "jspdf";
import * as appConfig from '../../app/app.constant';
import * as _ from 'lodash';
import { DecimalPipe } from '@angular/common';
import { PermissionsService } from './permission.service';
import { of } from 'rxjs';
import { CorpService } from './corp.service';
import { AuthenticationService } from './auth.service';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

@Injectable()
export class LGEDataService {
  private userDetails: IUser | undefined;
  private formCCName = '';
  private numPipe = new DecimalPipe('en-Us');
  private einException: string = '';
  private pendingApprovalFormCCData: any[] = [];
  private approvedFormccData = null;
  private isAdminId = null;
  private isAdminRejectId: number = 0;
  private orgInfoData = null;
  private controlReportData = null;

  constructor(
    private http: HttpClient,
    private permissionService: PermissionsService,
    private _corpService: CorpService,
    private _authService: AuthenticationService
  ) {}
  //Test
  public getTestData(): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.GET_DATA,
      session: this._authService.getSession(),
      data: {},
    });
    // .
    // then(result => {
    //     // Data can exist within its own state or as part of a screen state
    //     // You can dispatch actions here or from the effect
    //     // this.store.dispatch(new data.LoadMyDataAction(result as IMyData[]));
    //     // or
    //     // this.store.dispatch(new home.LoadMyDataAction(result as IHome[]));
    //     resolve(result);
    // })
    // .catch((error:Error) => {
    //     reject(error.message);
    // });
  }

  public externalUserStatusCheckMVC(externalEmail: string): Observable<any> {
    let url: string = `${environment.MVC_URL}/AppData/UserStatusCheck/get?externalEmail=${externalEmail}`;
    return this.http.get(url).pipe(map((res) => res));
  }

  public externalEmailCheckMVC(externalEmail: string): Observable<any> {
    let url: string = `${environment.MVC_URL}/AppData/ExternalEmailCheck/get?externalEmail=${externalEmail}`;
    return this.http.get(url).pipe(map((res) => res));
  }

  public externalSubmitAccessRequestMVC(
    extData: IExternalData
  ): Observable<any> {
    let url: string = `${environment.MVC_URL}/AppData/RequestAccess`;
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
      responseType: 'text' as 'text',
    };
    return this.http.post(url, extData, httpOptions);
  }

  public UpdateExtProfileAccessStatusMVC(
    externalEmail: string
  ): Observable<any> {
    let url: string = `${environment.MVC_URL}/AppData/UpdateExtProfileAccessStatus/get?externalEmail=${externalEmail}`;
    return this.http.get(url);
  }

  public VerifyUserByGUIDMVC(email: string, guid: string): Observable<any> {
    let url: string = `${environment.MVC_URL}/AppData/VerifyUserByGUID/get?email=${email}&guid=${guid}`;
    return this.http.get(url);
  }

  public DownloadFormAsPDF(requestNo: string): Observable<any> {
    const mvcUrl = environment.MVC_URL;
    const corpSession = this.permissionService.getCorpCommonSessionInfo();
    const corpDataDef = encodeURIComponent(
      `{"ProcessDataAction":"GET_PDFBYREQUESTNO","AppDataDefinition":[${JSON.stringify(
        requestNo
      )}]}`
    );
    // const corpDataDef = encodeURIComponent(`{"ProcessDataAction":"GET_CONTROLREPORTBYFILEPATH","AppDataDefinition":[${JSON.stringify('//lgeenergy.int/shares/Group1/CCMS_TEST/Outbound/FoundationControlReport_03292019_051724.pdf')}]}`);

    let url = `${mvcUrl}/AppData/GetFormPDFFileData?sid=${corpSession.corpAuthToken}&userID=${corpSession.corpUn}&applicationID=${corpSession.appId}&corpProcessDataDefinition=${corpDataDef}`;
    // window.open(url, '_blank');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Accept: 'application/json',
    });
    return this.http.get(url, {
      headers: headers,
      responseType: 'blob' as 'json',
    });
  }

  public DownloadAttachmentFileById(
    attachId: string,
    attachType: string
  ): Observable<any> {
    const mvcUrl = environment.MVC_URL;
    const corpSession = this.permissionService.getCorpCommonSessionInfo();
    let corpDataDef: any;
    switch (attachType) {
      case 'CCW9':
        corpDataDef = encodeURIComponent(
          '{"ProcessDataAction":"DOWNLOADFORMCCW9FILE","AppDataDefinition":[' +
            attachId +
            ']}'
        );
        break;
      case 'CCAdd':
        corpDataDef = encodeURIComponent(
          '{"ProcessDataAction":"DOWNLOADFORMCCADDATTACHFILE","AppDataDefinition":[' +
            attachId +
            ']}'
        );
        break;
      case 'CI':
        corpDataDef = encodeURIComponent(
          '{"ProcessDataAction":"DOWNLOAD_FORMCI_ATTACHMENT","AppDataDefinition":[' +
            attachId +
            ']}'
        );
        break;
      case 'FO':
        corpDataDef = encodeURIComponent(
          '{"ProcessDataAction":"DOWNLOAD_FORMFO_ATTACHMENT","AppDataDefinition":[' +
            attachId +
            ']}'
        );
        break;
      case 'CG':
        corpDataDef = encodeURIComponent(
          '{"ProcessDataAction":"DOWNLOAD_FORMCG_ATTACHMENT","AppDataDefinition":[' +
            attachId +
            ']}'
        );
        break;
      case 'ES':
        corpDataDef = encodeURIComponent(
          '{"ProcessDataAction":"DOWNLOAD_FORMES_ATTACHMENT","AppDataDefinition":[' +
            attachId +
            ']}'
        );
        break;
      case 'PP':
        corpDataDef = encodeURIComponent(
          '{"ProcessDataAction":"DOWNLOAD_FORMPP_ATTACHMENT","AppDataDefinition":[' +
            attachId +
            ']}'
        );
        break;
      case 'MG':
        corpDataDef = encodeURIComponent(
          '{"ProcessDataAction":"DOWNLOAD_FORMMG_ATTACHMENT","AppDataDefinition":[' +
            attachId +
            ']}'
        );
        break;
    }
    let url = `${mvcUrl}/AppData/GetFileData?sid=${corpSession.corpAuthToken}&userID=${corpSession.corpUn}&applicationID=${corpSession.appId}&corpProcessDataDefinition=${corpDataDef}`;
    let headers: HttpHeaders = new HttpHeaders();
    headers.append('Content-Type', 'application/json');
    headers.append('corp-un', corpSession.userId);
    headers.append('corp-auth-token', corpSession.guid);
    var options = {
      method: 'Get',
      headers: headers,
      url: url,
      withCredentials: true,
      responseType: 'blob' as 'json',
    };
    return this.http.get(url, options);
  }

  public GetControlReportByFilePath(filePath: string): Observable<any> {
    const mvcUrl = environment.MVC_URL;
    const corpSession = this.permissionService.getCorpCommonSessionInfo();
    const corpDataDef = encodeURIComponent(
      `{"ProcessDataAction":"GET_CONTROLREPORTBYFILEPATH","AppDataDefinition":[${JSON.stringify(
        filePath
      )}]}`
    );
    let url = `${mvcUrl}/AppData/GetControlReportFile?sid=${corpSession.corpAuthToken}&userID=${corpSession.corpUn}&applicationID=${corpSession.appId}&corpProcessDataDefinition=${corpDataDef}`;
    // window.open(url, '_blank');
    return this.http.get(url, { responseType: 'blob' as 'json' });
  }

  public GenerateControlReportFormCC(result) {
    if (result.length > 0) {
      let prep = result.map((element) => {
        return { ...element, totalAmount: +element.totalAmount };
      });
      prep = prep.map((element) => {
        if (element.OrgInfo.isInternal) {
          return { ...element, isInternalEIN: 'Yes' };
        } else {
          return { ...element, isInternalEIN: 'No' };
        }
      });
      const crDoc = new jsPDF('p', 'pt');
      const col = [
        'Company',
        'Vendor Name',
        'Payable To',
        'Invoice Date',
        'Invoice No',
        'Request Id',
        'Total Invoice Amount',
        'Internal EIN',
      ];
      const rows = [];

      prep.forEach((element) => {
        const temp = [
          element.AccDistribution[0].company,
          element.OrgInfo.name,
          element.OrgInfo.payTo,
          element.FormCCOeBS.uploadInvoiceDate,
          element.FormCCOeBS.invoiceNo,
          element.requestNo,
          element.totalAmount,
          element.isInternalEIN,
        ];
        rows.push(temp);
      });
      const LGEData = [];
      prep.map((element) => {
        if (element.AccDistribution[0].company === '0100') {
          LGEData.push(element);
        }
      });
      const KUData = [];
      prep.map((element) => {
        if (element.AccDistribution[0].company === '0110') {
          KUData.push(element);
        }
      });
      // console.log('LGEData ', LGEData);
      // console.log('KUData ', KUData);
      let totalAmountLGE = '';
      let totalAmountKU = '';
      let totalAmount = '';
      totalAmountLGE = this.numPipe.transform(
        _.sumBy(LGEData, 'totalAmount'),
        '1.2-2'
      );
      totalAmountKU = this.numPipe.transform(
        _.sumBy(KUData, 'totalAmount'),
        '1.2-2'
      );
      totalAmount = this.numPipe.transform(
        _.sumBy(prep, 'totalAmount'),
        '1.2-2'
      );
      // totalAmount.toLocaleString();
      rows.map((element) => {
        element[6] = this.numPipe.transform(element[6], '1.2-2');
      });
      // console.log('totalAmount: ', totalAmount);
      autoTable(crDoc, {
        head: [col],
        body: rows,
        // startY: 10,
        margin: { left: 18, right: 18, top: 80 },
        styles: { overflow: 'linebreak', cellWidth: 'wrap' },
        columnStyles: {
          0: { cellWidth: 55 },
          1: { cellWidth: 'auto' },
          2: { cellWidth: 'auto' },
          3: { cellWidth: 60 },
          4: { cellWidth: 46 },
          5: { cellWidth: 50 },
          6: { cellWidth: 54 },
          7: { cellWidth: 47 },
        },
        didDrawPage: function (data) {
          crDoc.text('Charitable Contributions', 20, 40);
          crDoc.text('Control Report', 20, 60);
          let str = 'Page ' + data.pageCount;
          crDoc.setFontSize(10);
          let pageHeight =
            crDoc.internal.pageSize.height ||
            crDoc.internal.pageSize.getHeight();
          crDoc.text(str, data.settings.margin.left, pageHeight - 10);
        },
      });
      crDoc.text(
        'Total Amount :                $ ' + totalAmount,
        280,
        (crDoc as any).lastAutoTable.finalY + 30
      );
      crDoc.text(
        'Company Total: 0100     $ ' + totalAmountLGE,
        280,
        (crDoc as any).lastAutoTable.finalY + 50
      );
      crDoc.text(
        'Company Total: 0110     $ ' + totalAmountKU,
        280,
        (crDoc as any).lastAutoTable.finalY + 70
      );

      crDoc.save('Control-Report.pdf');
    }
  }

  public GenerateExtControlReport(result: any) {
    if (result.length > 0) {
      let updated = result.map((element: any) => {
        let newData = { ...element };
        newData.totalAmount = +element.totalAmount;
        // element.totalAmount = +(this.numPipe.transform(element.totalAmount.replace(',',''),'1.2-2'));
        if (element.OrgInfo.isInternal === false) {
          newData.isInternalEIN = 'No';
        } else {
          newData.isInternalEIN = 'Yes';
        }
        return newData;
      });
      const crDoc = new jsPDF('p', 'pt');
      // const crDoc = new jsPDF();
      const col = [
        [
          'Company',
          'Vendor Name',
          'Payable To',
          'Invoice Date',
          'Invoice No',
          'Request Id',
          'Total Invoice Amount',
          'Internal EIN',
        ],
      ];
      const rows = [];

      updated.forEach((element) => {
        const temp = [
          element.AccDistribution[0].company,
          element.OrgInfo.name,
          element.OrgInfo.payTo,
          element.FormExtOeBS.uploadInvoiceDate,
          element.FormExtOeBS.invoiceNo,
          element.requestNo,
          element.totalAmount,
          element.isInternalEIN,
        ];
        rows.push(temp);
      });
      const LGEData = [];
      updated.map((element) => {
        if (element.AccDistribution[0].company === '0100') {
          LGEData.push(element);
        }
      });
      const KUData = [];
      updated.map((element) => {
        if (element.AccDistribution[0].company === '0110') {
          KUData.push(element);
        }
      });
      // console.log('LGEData ', LGEData);
      // console.log('KUData ', KUData);
      let totalAmountLGE = '';
      let totalAmountKU = '';
      let totalAmount = '';
      totalAmountLGE = this.numPipe.transform(
        _.sumBy(LGEData, 'totalAmount'),
        '1.2-2'
      );
      totalAmountKU = this.numPipe.transform(
        _.sumBy(KUData, 'totalAmount'),
        '1.2-2'
      );
      totalAmount = this.numPipe.transform(
        _.sumBy(updated, 'totalAmount'),
        '1.2-2'
      );
      // totalAmount.toLocaleString();
      rows.map((element) => {
        element[6] = this.numPipe.transform(element[6], '1.2-2');
      });
      // console.log('totalAmount: ', totalAmount);
      autoTable(crDoc, {
        head: col,
        body: rows,
        // startY: 10,
        margin: { left: 18, right: 18, top: 80 },
        styles: { overflow: 'linebreak', cellWidth: 'wrap' },
        columnStyles: {
          0: { cellWidth: 55 },
          1: { cellWidth: 'auto' },
          2: { cellWidth: 'auto' },
          3: { cellWidth: 60 },
          4: { cellWidth: 46 },
          5: { cellWidth: 50 },
          6: { cellWidth: 54 },
          7: { cellWidth: 47 },
        },
        didDrawPage: function (data) {
          let formName = '';
          switch (result[0].requestNo.substring(0, 2)) {
            case 'CG':
              formName = 'Community Grants';
              break;
            case 'CI':
              formName = 'Community Investment';
              break;
            case 'PP':
              formName = 'Plant for the Planet';
              break;
            case 'ES':
              formName = 'Event Sponsorship';
              break;
          }
          crDoc.text(formName, 20, 40);
          crDoc.text('Control Report', 20, 60);
          let str = 'Page ' + data.pageCount;
          crDoc.setFontSize(10);
          let pageHeight =
            crDoc.internal.pageSize.height ||
            crDoc.internal.pageSize.getHeight();
          crDoc.text(str, data.settings.margin.left, pageHeight - 10);
        },
      });
      crDoc.text(
        'Total Amount :                $ ' + totalAmount,
        280,
        (crDoc as any).lastAutoTable.finalY + 30
      );
      crDoc.text(
        'Company Total: 0100     $ ' + totalAmountLGE,
        280,
        (crDoc as any).lastAutoTable.finalY + 50
      );
      crDoc.text(
        'Company Total: 0110     $ ' + totalAmountKU,
        280,
        (crDoc as any).lastAutoTable.finalY + 70
      );
      let title = '';
      switch (result[0].requestNo.substring(0, 2)) {
        case 'PP':
          title = 'Plant_for_the_Planet_OeBS_Control_Report.pdf';
          break;
        case 'CI':
          title = 'Community_Investment_OeBS_Control_Report.pdf';
          break;
        case 'CG':
          title = 'Community_Grants_OeBS_Control_Report.pdf';
          break;
        case 'ES':
          title = 'Event_Sponsorship_OeBS_Control_Report.pdf';
          break;
      }
      crDoc.save(title);
    }
  }

  public externalCharityCheck(ein: string): Observable<any> {
    let url: string = `${environment.MVC_URL}/AppData/CharityCheckExternal/get?ein=${ein}`;
    return this.http.get(url, { responseType: 'text' }).pipe(map((res) => res));
  }

  public forgotPassword(data: any): Observable<any> {
    let postData: FormData = new FormData();
    postData.append('userId', data.email);
    postData.append('appID', `${environment.APPLICATION_ID}`);
    postData.append(
      'linkLocation',
      `${environment.APP_URL}/CCMS/#/set-password`
    );
    // let requestOpts = {
    //     url: `${environment.API_URL}/APICorpCommon/AppData/LostPasswordPost`,
    //     data: postData
    // };
    let url = `${environment.API_URL}/APICorpCommon/AppData/LostPasswordPost`;
    return this.http.post(url, postData, {
      withCredentials: true,
      responseType: 'json' as 'json',
    });
  }

  private urlParamifyData = (data) => {
    if (typeof data !== 'object') {
      throw new Error(
        'Cannot paramify non-object input. Input was of type: ' + typeof data
      );
    }
    var str = [];
    Object.keys(data).forEach(function (prop) {
      var name = encodeURIComponent(prop);
      var value = data[prop];
      // Anything complex, we need to JSON.Stringify
      if (typeof value === 'object') {
        value = JSON.stringify(value);
      }
      var val = encodeURIComponent(value);
      str.push(name + '=' + val);
    });
    return str.join('&');
  };

  public setPassword(data: ISetPassword): Observable<any> {
    let postData: FormData = new FormData();
    postData.append('userId', data.email);
    postData.append(
      'password',
      data.sid ? data.password : data.oldPassword || 'password'
    );
    postData.append('changeNewPassword', data.password);
    postData.append('changeNewPasswordConfirm', data.confirmPassword);
    postData.append('appID', `${environment.APPLICATION_ID}`);
    postData.append('applicationID', `${environment.APPLICATION_ID}`);
    postData.append('sid', data.sid || '');
    let url = `${environment.API_URL}/APICorpCommon/AppData/ChangePasswordPost`;
    var options = {
      withCredentials: true,
      responseType: 'json' as 'json',
    };
    return this.http.post(url, postData, options);
  }

  public externalEmailCheck(data: string): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.EXTERNAL_EMAIL_CHECK,
      data,
      session: this._authService.getSession(),
    });
  }

  public getExternalUsers(): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.GET_EXTERNAL_USERS,
      session: this._authService.getSession(),
      data: {},
    });
  }

  public externalProfileIUD(data: IExternalData): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.EXTERNAL_PROFILE_IUD,
      data,
      session: this._authService.getSession(),
    });
  }

  public externalProfileEditDetails(data: IExternalData): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.EXTERNAL_PROFILE_EDITDETAILS,
      data,
      session: this._authService.getSession(),
    });
  }

  public externalProfileApproveReject(dataObj: IExternalData): Observable<any> {
    let data: IExternalData = Object.assign({}, dataObj, {
      ccSession: this._authService.getSession(),
    });
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.EXTERNAL_PROFILE_IUD,
      data,
      session: this._authService.getSession(),
    });
  }

  public extProfileApproveReject(dataObj: IExternalData): Observable<any> {
    let data: IExternalData = Object.assign({}, dataObj, {
      ccSession: this._authService.getSession(),
    });

    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.EXTERNAL_PROFILE_IUD,
      data,
      session: this._authService.getSession(),
    });
  }

  public postSignUp(formData: ISignUp): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.POST_SIGN_UP,
      session: this._authService.getSession(),
      data: JSON.stringify(formData),
    });
  }

  public getRegisteredStatus(): Observable<any> {
    return this._corpService
      .postData({
        actionKey: appConfig.DATA_KEYWORDS.GET_REGISTERED_STATUS,
        session: this._authService.getSession(),
        data: {},
      })
      .pipe(
        map((result: any) => result),
        catchError((error: Error) => of(error))
      );
  }

  public postTestData(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.POST_DATA,
      session: this._authService.getSession(),
      data: JSON.stringify(data),
    });
  }

  public getExternalUserByEmail(extEmail: string): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.GET_EXTERNAL_USER_BY_EMAIL,
      session: this._authService.getSession(),
      data: [extEmail],
    });
  }

  // mayur

  public getEmployeeDetails(): any {
    if (this._authService.getSession()) {
      return this._authService.getSession();
    }
  }

  public hasRoles(role: string): boolean {
    let roles: any = this._authService.getSession().userRolesForApplication;
    roles = roles.split('|');
    if (roles.indexOf(role) >= 0) {
      return true;
    }
    return false;
  }

  public ccFormIUD(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.FORMCCIUD,
      data,
      session: this._authService.getSession(),
    });
  }

  public formCCByUserId(): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.FORMCC_BY_USERID,
      session: this._authService.getSession(),
      data: [],
    });
  }

  public formCCById(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.FORMCC_BY_ID,
      data,
      session: this._authService.getSession(),
    });
  }

  public FormCCByStatusIdExceptDraft(): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.FORMCC_BY_STATUSID_EXCEPT_DRAFT,
      session: this._authService.getSession(),
      data: [],
    });
  }

  public FormCCByStatusId(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.FORMCC_BY_STATUSID,
      session: this._authService.getSession(),
      data: [data],
    });
  }

  public GetFormCCForValidateInvoive(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.GET_FORMCC_FOR_VALIDATE_INVOICE,
      session: this._authService.getSession(),
      data: [data],
    });
  }

  public GetFormCCForValidateInvoiveList(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.GET_FORMCC_FOR_VALIDATE_INVOICE_LIST,
      session: this._authService.getSession(),
      data: [data],
    });
  }

  public GetFormCCForUploadInvoive(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.GET_FORMCC_FOR_UPLOAD_INVOICE,
      session: this._authService.getSession(),
      data: [data],
    });
  }
  public GetFormCCForUploadInvoiveList(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.GET_FORMCC_FOR_UPLOAD_INVOICE_LIST,
      session: this._authService.getSession(),
      data: [data],
    });
  }

  public GetFormCCForInvoiceSentToOeBS(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.GET_FORMCC_FOR_INVOICE_SENT_TO_OEBS,
      session: this._authService.getSession(),
      data: [data],
    });
  }

  public GetFormCCForControlReport(): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.GET_FORMCC_FOR_CONTROL_REPORT,
      session: this._authService.getSession(),
      data: [],
    });
  }

  public getPendingApprovalFormCCDetails(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.GET_FORMCC_FOR_APPROVAL,
      data,
      session: this._authService.getSession(),
    });
  }

  public AprrovedOrRejectFormCC(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.APRROVED_OR_REJECT_FORMCC,
      data,
      session: this._authService.getSession(),
    });
  }

  setFormCCName(formCCName: any) {
    this.formCCName = formCCName;
  }

  getFormCCName() {
    return this.formCCName;
  }

  setEINExceptionFilter(ein: any) {
    this.einException = ein;
  }

  getEINExceptionFilter() {
    return this.einException;
  }

  public checkFormCCName(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.CHECK_FORMCC_NAME,
      data,
      session: this._authService.getSession(),
    });
  }

  public getEmployeeByEmpId(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.GET_EMPLOYEE_BY_ID,
      data,
      session: this._authService.getSession(),
    });
  }

  public OverrideUserDetail(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.OVERRIDE_USER_DETAIL_IUD,
      data,
      session: this._authService.getSession(),
    });
  }

  public EINOrgInfoDetailIUD(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.EIN_ORGINFO_DETAIL_IUD,
      data,
      session: this._authService.getSession(),
    });
  }

  public GetOverrideUserDetail(): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.GET_OVERRIDE_USER_DETAIL,
      session: this._authService.getSession(),
      data: [],
    });
  }

  public GetEINOrgInfoDetail(): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.GET_EIN_ORGINFO_DETAIL,
      session: this._authService.getSession(),
      data: [],
    });
  }

  public AlmDetailsIUD(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.ALM_DETAILS_IUD,
      data,
      session: this._authService.getSession(),
    });
  }

  public GetAlmDeatilsByCombination(): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.GET_ALM_DEAITLS_BY_COMBINATION,
      session: this._authService.getSession(),
      data: [],
    });
  }

  public EmailTemplateIUD(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.EMAIL_TEMPLATE_IUD,
      data,
      session: this._authService.getSession(),
    });
  }

  public GetEmailTemplates(): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.GET_EMAIL_TEMPLATES,
      session: this._authService.getSession(),
      data: [],
    });
  }

  public GetEmailTemplateById(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.GET_EMAIL_TEMPLATE_BY_ID,
      data,
      session: this._authService.getSession(),
    });
  }

  public GetUsersGroupForRole(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.GET_USERS_GROUP_FOR_ROLE,
      session: this._authService.getSession(),
      data: [data],
    });
  }

  public AccDistInfo_Update(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.ACC_DIST_INFO_UPDATE,
      data,
      session: this._authService.getSession(),
    });
  }

  public AccDistInfo_GetByName(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.ACC_DIST_INFO_GET_BY_NAME,
      data: [data],
      session: this._authService.getSession(),
    });
  }

  public AccDistInfo_GetActiveByName(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.ACC_DIST_INFO_GET_ACTIVE_BY_NAME,
      data: [data],
      session: this._authService.getSession(),
    });
  }

  public DeleteAccDistInfoByName(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.DELETE_ACCDISTINFO_BY_NAME,
      data: [data],
      session: this._authService.getSession(),
    });
  }

  public ProjectTaskInfo_GetByName(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.PROJECT_TASK_GET_BY_NAME,
      data: [data],
      session: this._authService.getSession(),
    });
  }

  public ProjectTaskInfo_GetActiveByName(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.PROJECT_TASK_GET_ACTIVE_BY_NAME,
      data: [data],
      session: this._authService.getSession(),
    });
  }

  public DeleteProjectTaskInfo(): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.DELETE_PROJECTTASK_INFO,
      data: [],
      session: this._authService.getSession(),
    });
  }

  public ProjectTaskInfo_Update(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.PROJECT_TASK_INFO_UPDATE,
      data,
      session: this._authService.getSession(),
    });
  }

  public ValidateApprovedFormCCAPI(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.VALIDATE_APPROVED_FORMCC_API,
      data: [data],
      session: this._authService.getSession(),
    });
  }

  public UploadApprovedFormCCAPI(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.UPLOAD_APPROVED_FORMCC_API,
      data: [data],
      session: this._authService.getSession(),
    });
  }

  public CharityCheck(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.CHARITY_CHECK,
      data: [data],
      session: this._authService.getSession(),
    });
  }

  public CharityCheckGuideStar(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.CHARITY_CHECK_API,
      data: [data],
      session: this._authService.getSession(),
    });
  }

  public GetInvoiceStatus(): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.GET_INVOICE_STATUS_API,
      data: [],
      session: this._authService.getSession(),
    });
  }

  public Validate_Project_Task(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.VALIDATE_PROJECT_TASK,
      data: [data],
      session: this._authService.getSession(),
    });
  }

  public SendEmailNotifications(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.COMPOSE_EMAIL,
      data: [data],
      session: this._authService.getSession(),
    });
  }

  public SendAwardDeclineEmail(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.COMPOSE_AWARDDECLINE_EMAIL,
      data: [data],
      session: this._authService.getSession(),
    });
  }

  public GetFormCCForPaymentAsCredit(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.GET_FORMCC_FOR_PAYMENT_AS_CREDIT,
      data: [data],
      session: this._authService.getSession(),
    });
  }

  public UpdateFormCCForPaymentAsCredit(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.UPDATE_FORMCC_FOR_PAYMENT_AS_CREDIT,
      data: [data],
      session: this._authService.getSession(),
    });
  }

  public GetLGEEmployees(): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.GET_LGE_EMPLOYEES,
      data: [],
      session: this._authService.getSession(),
    });
  }

  // batch job
  public NotifyApprovarForOutstandingTask(): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.NOTIFY_APPROVER_FOR_OUTSTANDING_TASK,
      data: [],
      session: this._authService.getSession(),
    });
  }

  public ResetApprovarForOutstandingTask(): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.RESET_APPROVER_FOR_OUTSTANDING_TASK,
      data: [],
      session: this._authService.getSession(),
    });
  }

  public GetDOAForApprover(): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.GET_DOA_AND_NOTIFY_ADMIN,
      data: [],
      session: this._authService.getSession(),
    });
  }
  public DeleteAllApproverDOALog(): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.RESET_DOA_AND_NOTIFY_ADMIN,
      data: [],
      session: this._authService.getSession(),
    });
  }

  public DownloadFormccW9File(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.DOWNLOAD_FORMCC_W9FILE,
      data: [data],
      session: this._authService.getSession(),
    });
  }

  public DownloadFormccAddAttachFile(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.DOWNLOAD_FORMCC_ADDATTACH_FILE,
      data: [data],
      session: this._authService.getSession(),
    });
  }

  public DownloadFormccAllAddAttachFile(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.DOWNLOAD_ALL_FORMCC_ADDATTACH_FILE,
      data: [data],
      session: this._authService.getSession(),
    });
  }

  public GetEmployeeHierarchyTest(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.GET_EMPLOYEE_HIERARCHY_TEST,
      data: [data],
      session: this._authService.getSession(),
    });
  }

  public GetAccDistInfo(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.GET_ACCDIST_INFO,
      data: [data],
      session: this._authService.getSession(),
    });
  }

  // test

  public customerTypeGet(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.TESTMVC_CALL,
      data: [data],
      session: this._authService.getSession(),
    });
  }

  public Test(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.TEST,
      data: [data],
      session: this._authService.getSession(),
    });
  }

  //Form Ext starts here

  //Form CI

  public ciFormIUD(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.FORMCI_IUD,
      data,
      session: this._authService.getSession(),
    });
  }

  public formCIById(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.FORMCI_BY_ID,
      data,
      session: this._authService.getSession(),
    });
  }

  public FormCIByStatusIdExceptDraft(): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.FORMCI_BY_STATUSID_EXCEPT_DRAFT,
      session: this._authService.getSession(),
      data: [],
    });
  }

  public formExtByUserId(): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.FORMEXT_BY_USERID,
      session: this._authService.getSession(),
      data: this.permissionService.getUserId(),
    });
  }

  public GetFormCIPendingOrApproved(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.GET_FORMCI_PENDING_OR_APPROVED,
      data,
      session: this._authService.getSession(),
    });
  }

  public AprroveRejectWithdrawFormCI(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.APRROVE_REJECT_WITHDRAW_FORMCI,
      data,
      session: this._authService.getSession(),
    });
  }

  public foundationFormIUD(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.FORMFO_IUD,
      data,
      session: this._authService.getSession(),
    });
  }

  //  form FO
  public formFOById(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.FORMFO_BY_ID,
      data,
      session: this._authService.getSession(),
    });
  }

  public FormFOByStatusIdExceptDraft(): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.FORMFO_BY_STATUSID_EXCEPT_DRAFT,
      session: this._authService.getSession(),
      data: [],
    });
  }

  public GetFormFOPendingOrApproved(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.GET_FORMFO_PENDING_OR_APPROVED,
      data,
      session: this._authService.getSession(),
    });
  }

  public GetFormPPPendingOrApproved(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.GET_FORMPP_PENDING_OR_APPROVED,
      data,
      session: this._authService.getSession(),
    });
  }

  public AprroveRejectWithdrawFormFO(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.APRROVE_REJECT_WITHDRAW_FORMFO,
      data,
      session: this._authService.getSession(),
    });
  }

  //form PP
  public ppFormIUD(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.FORMPP_IUD,
      data,
      session: this._authService.getSession(),
    });
  }

  public AccDistIUD(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.ACCDISTEXTIUD,
      data,
      session: this._authService.getSession(),
    });
  }
  public formPPById(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.FORMPP_BY_ID,
      data,
      session: this._authService.getSession(),
    });
  }

  public FormPPByStatusIdExceptDraft(): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.FORMPP_BY_STATUSID_EXCEPT_DRAFT,
      session: this._authService.getSession(),
      data: [],
    });
  }
  public AprroveRejectWithdrawFormPP(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.APRROVE_REJECT_WITHDRAW_FORMPP,
      data,
      session: this._authService.getSession(),
    });
  }

  public async checkExpirationForm(form: String) {
    try {
      let response = await this.GetActiveForm();
      if (response) console.log(response);
      else console.error(`Error: ${response}`);
    } catch (error) {
      console.error(`ERROR ${error}`);
    }
  }

  public GetActiveForm(): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.GETACTIVEFORMS,
      session: this._authService.getSession(),
      data: [],
    });
  }

  public checkFormExpired(form:String): Observable<boolean> {
    var valid = 'ADMIN';
    switch(form) {
      case 'PFTP':
        valid
    }
    return this.GetActiveForm().pipe(
      map(data => {
        let isExpired = (data.find((item) => item === form) === undefined);
        return true;
      })
    )
  }

  public GetFormConfigs(): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.GETFORMCONFIGS,
      session: this._authService.getSession(),
      data: [],
    });
  }
  public FormConfigsIUD(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.FORMCONFIGSIUD,
      data,
      session: this._authService.getSession(),
    });
  }

  public VerifyExceptionEIN(): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.EXCEPTIONEINCHECK,
      session: this._authService.getSession(),
      data: [],
    });
  }
  public GetOpenRequests(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.GETOPENREQUESTS,
      data,
      session: this._authService.getSession(),
    });
  }
  public GetClosedRequests(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.GETCLOSEDREQUESTS,
      data,
      session: this._authService.getSession(),
    });
  }
  public UpdateFormStatus_Close(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.CLOSREQUESTS,
      data,
      session: this._authService.getSession(),
    });
  }

  public GetFormPPForValidateInvoive(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.GET_FORMPP_FOR_VALIDATE_INVOICE,
      session: this._authService.getSession(),
      data: [data],
    });
  }

  public GetFormPPForUploadInvoive(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.GET_FORMPP_FOR_UPLOAD_INVOICE,
      session: this._authService.getSession(),
      data: [data],
    });
  }

  public GetFormPPForInvoiceSentToOeBS(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.GET_FORMPP_FOR_INVOICE_SENT_TO_OEBS,
      session: this._authService.getSession(),
      data: [data],
    });
  }

  public GetFormPPForControlReport(): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.GET_FORMPP_FOR_CONTROL_REPORT,
      session: this._authService.getSession(),
      data: [],
    });
  }
  public GetFormCIForValidateInvoive(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.GET_FORMCI_FOR_VALIDATE_INVOICE,
      session: this._authService.getSession(),
      data: [data],
    });
  }

  public GetFormCIForUploadInvoive(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.GET_FORMCI_FOR_UPLOAD_INVOICE,
      session: this._authService.getSession(),
      data: [data],
    });
  }

  public GetFormCIForInvoiceSentToOeBS(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.GET_FORMCI_FOR_INVOICE_SENT_TO_OEBS,
      session: this._authService.getSession(),
      data: [data],
    });
  }
  public GetFormCIForControlReport(): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.GET_FORMCI_FOR_CONTROL_REPORT,
      session: this._authService.getSession(),
      data: [],
    });
  }

  public GetToAwardDeclineAddList(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.GETTOAWARDDECLINEADD,
      data,
      session: this._authService.getSession(),
    });
  }

  public ValidateApprovedFormExtAPI(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.VALIDATE_APPROVED_FORMEXT_API,
      data: [data],
      session: this._authService.getSession(),
    });
  }
  public UploadApprovedFormExtAPI(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.UPLOAD_APPROVED_FORMEXT_API,
      data: [data],
      session: this._authService.getSession(),
    });
  }
  public GetFormPPForPaymentAsCredit(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.GET_FORMPP_FOR_PAYMENT_AS_CREDIT,
      data: [data],
      session: this._authService.getSession(),
    });
  }
  public GetFormCIForPaymentAsCredit(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.GET_FORMCI_FOR_PAYMENT_AS_CREDIT,
      data: [data],
      session: this._authService.getSession(),
    });
  }
  public UpdateFormExtForPaymentAsCredit(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.UPDATE_FORMEXT_FOR_PAYMENT_AS_CREDIT,
      data: [data],
      session: this._authService.getSession(),
    });
  }

  public DownloadFormFOAttachFile(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.DOWNLOAD_FORMFO_ATTACHMENT,
      data: [data],
      session: this._authService.getSession(),
    });
  }
  public DownloadFormCIAttachFile(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.DOWNLOAD_FORMCI_ATTACHMENT,
      data: [data],
      session: this._authService.getSession(),
      // url: ""
    });
  }
  public DownloadFormPPAttachFile(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.DOWNLOAD_FORMPP_ATTACHMENT,
      data: [data],
      session: this._authService.getSession(),
    });
  }
  public DownloadAllFormFOAddAttachFile(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.DOWNLOADALL_FORMFO_ADDATTACHMENT,
      data: [data],
      session: this._authService.getSession(),
    });
  }
  public DownloadAllFormCIAddAttachFile(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.DOWNLOADALL_FORMCI_ADDATTACHMENT,
      data: [data],
      session: this._authService.getSession(),
    });
  }
  public DownloadAllFormPPAddAttachFile(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.DOWNLOADALL_FORMPP_ADDATTACHMENT,
      data: [data],
      session: this._authService.getSession(),
    });
  }
  public DeleteFormFOAttachFile(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.DELETE_FORMFOATTACHMENT,
      data: [data],
      session: this._authService.getSession(),
    });
  }
  public DeleteFormCIAttachFile(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.DELETE_FORMCIATTACHMENT,
      data: [data],
      session: this._authService.getSession(),
    });
  }
  public DeleteFormPPAttachFile(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.DELETE_FORMPPATTACHMENT,
      data: [data],
      session: this._authService.getSession(),
    });
  }
  public DeleteAllFormFOAddAttachFile(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.DELETEALL_FORMFO_ADDATTACHMENT,
      data: [data],
      session: this._authService.getSession(),
    });
  }
  public DeleteAllFormCIAddAttachFile(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.DELETEALL_FORMCI_ADDATTACHMENT,
      data: [data],
      session: this._authService.getSession(),
    });
  }
  public DeleteAllFormPPAddAttachFile(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.DELETEALL_FORMPP_ADDATTACHMENT,
      data: [data],
      session: this._authService.getSession(),
    });
  }

  public DeleteFromFileService(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.DELETE_FROMFILESERVICES,
      data: [data],
      session: this._authService.getSession(),
    });
  }

  public ImportFileFromFileService(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.DOWNLOAD_FROMFILESERVICES,
      data: [data],
      session: this._authService.getSession(),
    });
  }
  // get eins that has null subsection to update
  public GetSubsection(): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.GET_SUBSECTION,
      data: [],
      session: this._authService.getSession(),
    });
  }
  // get list of tax-exempt subsections available for 501
  public GetTaxExemptSubsections(): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.GET_TAXEXEMPTSUBSECTIONS,
      data: [],
      session: this._authService.getSession(),
    });
  }

  public TaxExemptSubsectionsIUD(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.IUD_TAXEXEMPTSUBSECTIONS,
      data: [data],
      session: this._authService.getSession(),
    });
  }

  // get list of payment options
  public GetPaymentOptions(): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.GET_PAYMENTOPTIONS,
      data: [],
      session: this._authService.getSession(),
    });
  }

  // Update status of Payment Options
  public PaymentOptionIUD(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.IUD_PAYMENTOPTIONS,
      data: [data],
      session: this._authService.getSession(),
    });
  }

  // get list of payment processor and payment options combination
  public GetPaymentProcessor(): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.GET_PAYMENTPROCESSOR,
      data: [],
      session: this._authService.getSession(),
    });
  }

  public PaymentProcessorIUD(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.IUD_PAYMENTPROCESSOR,
      data: [data],
      session: this._authService.getSession(),
    });
  }

  public GetPaymentConfigs(): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.GET_PAYMENTCONFIGS,
      data: [],
      session: this._authService.getSession(),
    });
  }

  public PaymentConfigIUD(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.IUD_PAYMENTCONFIGS,
      data: [data],
      session: this._authService.getSession(),
    });
  }

  public GetFoundationPaymentRequests(): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.GET_FOUNDATIONPAYMENTREQUESTS,
      data: [],
      session: this._authService.getSession(),
    });
  }

  public GetProcessedFoundationPaymentRequests(): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.GET_PROCESSEDFOUNDATIONPAYMENTREQUESTS,
      data: [],
      session: this._authService.getSession(),
    });
  }

  public ProcessFoundationPaymentRequests(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.PROCESS_FOUNDATIONPAYMENTREQUESTS,
      data: [data],
      session: this._authService.getSession(),
    });
  }

  public UpdateFoundationPaymentRequestsStatus(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey:
        appConfig.DATA_KEYWORDS.UPDATE_FOUNDATIONPAYMENTREQUESTS_CHECKSTATUS,
      data: [data],
      session: this._authService.getSession(),
    });
  }

  //form MG
  public mgFormIUD(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.FORMMG_IUD,
      data,
      session: this._authService.getSession(),
    });
  }

  public formMGById(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.FORMMG_BY_ID,
      data,
      session: this._authService.getSession(),
    });
  }

  public FormMGByStatusIdExceptDraft(): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.FORMMG_BY_STATUSID_EXCEPT_DRAFT,
      session: this._authService.getSession(),
      data: [],
    });
  }

  public AprrovedOrRejectFormMG(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.APRROVED_OR_REJECT_FORMMG,
      data,
      session: this._authService.getSession(),
    });
  }

  //form CG
  public formCGIUD(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.FORMCG_IUD,
      data,
      session: this._authService.getSession(),
    });
  }

  public formCGById(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.FORMCG_BY_ID,
      data,
      session: this._authService.getSession(),
    });
  }

  public FormCGByStatusIdExceptDraft(): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.FORMCG_BY_STATUSID_EXCEPT_DRAFT,
      session: this._authService.getSession(),
      data: [],
    });
  }

  public AprroveRejectWithdrawFormCG(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.APPRROVE_REJECT_WITHDRAW_FORMCG,
      data,
      session: this._authService.getSession(),
    });
  }

  public GetFormCGPendingOrApproved(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: appConfig.DATA_KEYWORDS.GET_FORMCG_PENDING_OR_APPROVED,
      data,
      session: this._authService.getSession(),
    });
  }

  public GetFormCGForValidateInvoive(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.GET_FORMCG_FOR_VALIDATE_INVOICE,
      session: this._authService.getSession(),
      data: [data],
    });
  }

  public GetFormCGForUploadInvoive(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.GET_FORMCG_FOR_UPLOAD_INVOICE,
      session: this._authService.getSession(),
      data: [data],
    });
  }

  public GetFormCGForInvoiceSentToOeBS(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.GET_FORMCG_FOR_INVOICE_SENT_TO_OEBS,
      session: this._authService.getSession(),
      data: [data],
    });
  }

  public GetFormCGForControlReport(): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.GET_FORMCG_FOR_CONTROL_REPORT,
      session: this._authService.getSession(),
      data: [],
    });
  }

  public GetFormCGForPaymentAsCredit(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: appConfig.DATA_KEYWORDS.GET_FORMCG_FOR_PAYMENT_AS_CREDIT,
      data: [data],
      session: this._authService.getSession(),
    });
  }

  public ApproveRejectFormCGList(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: 'APPROVEREJECTFORMCGLIST',
      data: JSON.stringify(data),
      session: this._authService.getSession(),
    });
  }

  public ApproveRejectFormPPList(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: 'APPROVEREJECTFORMPPLIST',
      data: JSON.stringify(data),
      session: this._authService.getSession(),
    });
  }

  public DeleteFormIntList(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: 'DELETEFORMINTLIST',
      data: JSON.stringify(data),
      session: this._authService.getSession(),
    });
  }

  // Form ES

  public formESIUD(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: 'FORMES_IUD',
      data,
      session: this._authService.getSession(),
    });
  }

  public formESById(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: 'FORMES_BY_ID',
      data,
      session: this._authService.getSession(),
    });
  }

  public FormESByStatusIdExceptDraft(): Observable<any> {
    return this._corpService.getData({
      actionKey: 'FORMES_BY_STATUSID_EXCEPT_DRAFT',
      session: this._authService.getSession(),
      data: [],
    });
  }

  public AprroveRejectWithdrawFormES(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: 'APPRROVED_OR_REJECT_FORMES',
      data,
      session: this._authService.getSession(),
    });
  }

  public GetFormESPendingOrApproved(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: 'GET_FORMES_PENDING_OR_APPROVED',
      data,
      session: this._authService.getSession(),
    });
  }

  public ApproveRejectFormESList(data: any): Observable<any> {
    return this._corpService.postData({
      actionKey: 'APPROVE_REJECT_FORMES_LIST',
      data: JSON.stringify(data),
      session: this._authService.getSession(),
    });
  }

  public GetFormESForValidateInvoive(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: 'GET_FORMES_FOR_VALIDATE_INVOICE',
      session: this._authService.getSession(),
      data: [data],
    });
  }

  public GetFormESForUploadInvoive(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: 'GET_FORMES_FOR_UPLOAD_INVOICE',
      session: this._authService.getSession(),
      data: [data],
    });
  }

  public GetFormESForInvoiceSentToOeBS(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: 'GET_FORMES_FOR_INVOICE_SENT_TO_OEBS',
      session: this._authService.getSession(),
      data: [data],
    });
  }

  public GetFormESForControlReport(): Observable<any> {
    return this._corpService.getData({
      actionKey: 'GET_FORMES_FOR_CONTROL_REPORT',
      session: this._authService.getSession(),
      data: [],
    });
  }

  public GetFormESForPaymentAsCredit(data: any): Observable<any> {
    return this._corpService.getData({
      actionKey: 'GET_FORMES_FOR_PAYMENT_AS_CREDIT',
      data: [data],
      session: this._authService.getSession(),
    });
  }

  setpendingApprovalFormCCData(pendingApprovalFormCCData: any[]) {
    // console.log('Service: pendingApprovalFormCC')
    this.pendingApprovalFormCCData = pendingApprovalFormCCData;
  }

  getpendingApprovalFormCCData() {
    return this.pendingApprovalFormCCData;
  }

  setApprovedFormCCData(formccId: null) {
    this.approvedFormccData = formccId;
  }

  getApprovedFormCCData() {
    return this.approvedFormccData;
  }

  setIsAdminReadOnly(formccId: null) {
    this.isAdminId = formccId;
  }

  getIsAdminReadOnly() {
    return this.isAdminId;
  }

  setIsAdminReject(data: null) {
    this.isAdminRejectId = data ?? 1;
  }

  getIsAdminReject() {
    return this.isAdminRejectId;
  }

  setOrgInfoDetails(orgInfoData: null) {
    this.orgInfoData = orgInfoData;
  }

  getOrgInfoDetails() {
    return this.orgInfoData;
  }

  setControlReportData(controlReportData: null) {
    this.controlReportData = controlReportData;
    // // console.log('Service: ', this.controlReportData)
  }

  getControlReportData() {
    return this.controlReportData;
  }
}
